import { render, staticRenderFns } from "./lamsAuthRegAccidentRecord.vue?vue&type=template&id=77797352&scoped=true&"
import script from "./lamsAuthRegAccidentRecord.vue?vue&type=script&lang=js&"
export * from "./lamsAuthRegAccidentRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77797352",
  null
  
)

export default component.exports